interface FarmIconProps {
  status: 'active' | 'stopped' | 'canceled' | 'new'
  className?: string
}

export const FarmIcon = (props: FarmIconProps) => {
  const { status = 'new', className } = props
  const fillColor = {
    active: 'var(--status-green-fill)',
    stopped: 'var(--status-grey-fill)',
    canceled: 'var(--status-red-fill)',
    new: '#FFF',
  }[status]
  const pathColor = {
    active: 'var(--status-green-stroke)',
    stopped: 'var(--status-grey-stroke)',
    canceled: 'var(--status-red-stroke)',
    new: '#667085',
  }[status]

  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="52" height="52" rx="26" fill={fillColor} />
      <path
        d="M25.9978 26.9756C25.8418 26.9756 25.7053 26.9366 25.5688 26.8781L12.8938 20.5406C12.7289 20.4607 12.5899 20.3361 12.4926 20.1809C12.3953 20.0257 12.3438 19.8462 12.3438 19.6631C12.3438 19.4799 12.3953 19.3005 12.4926 19.1453C12.5899 18.9901 12.7289 18.8654 12.8938 18.7856L25.5688 12.4481C25.8418 12.3116 26.1733 12.3116 26.4463 12.4481L39.1213 18.7856C39.2861 18.8654 39.4251 18.9901 39.5224 19.1453C39.6197 19.3005 39.6713 19.4799 39.6713 19.6631C39.6713 19.8462 39.6197 20.0257 39.5224 20.1809C39.4251 20.3361 39.2861 20.4607 39.1213 20.5406L26.4463 26.8781C26.3098 26.9561 26.1538 26.9756 26.0173 26.9756H25.9978ZM15.5068 19.6631L25.9978 24.9086L36.4888 19.6631L25.9978 14.4176L15.5068 19.6631Z"
        fill={pathColor}
      />
      <path
        d="M25.9978 33.3138C25.8418 33.3138 25.7053 33.2748 25.5688 33.2163L12.8938 26.8788C12.7289 26.7989 12.5899 26.6743 12.4926 26.5191C12.3953 26.3639 12.3438 26.1844 12.3438 26.0013C12.3438 25.8181 12.3953 25.6387 12.4926 25.4835C12.5899 25.3283 12.7289 25.2036 12.8938 25.1238L19.2313 21.9648C19.7188 21.7308 20.3038 21.9258 20.5378 22.3938C20.7718 22.8813 20.5768 23.4663 20.1088 23.7003L15.5068 26.0013L25.9978 31.2468L36.4888 26.0013L31.8868 23.7003C31.7712 23.6444 31.6681 23.5659 31.5836 23.4693C31.4991 23.3727 31.4349 23.2601 31.3948 23.1381C31.3548 23.0162 31.3397 22.8874 31.3505 22.7596C31.3614 22.6317 31.3978 22.5073 31.4578 22.3938C31.6918 21.9063 32.2768 21.7113 32.7643 21.9648L39.1018 25.1238C39.2666 25.2036 39.4056 25.3283 39.5029 25.4835C39.6002 25.6387 39.6518 25.8181 39.6518 26.0013C39.6518 26.1844 39.6002 26.3639 39.5029 26.5191C39.4056 26.6743 39.2666 26.7989 39.1018 26.8788L26.4268 33.2163C26.2903 33.2943 26.1343 33.3138 25.9978 33.3138Z"
        fill={pathColor}
      />
      <path
        d="M25.9978 39.6497C25.8418 39.6497 25.7053 39.6107 25.5688 39.5522L12.8938 33.2147C12.7289 33.1349 12.5899 33.0102 12.4926 32.855C12.3953 32.6998 12.3438 32.5204 12.3438 32.3372C12.3438 32.1541 12.3953 31.9746 12.4926 31.8194C12.5899 31.6642 12.7289 31.5396 12.8938 31.4597L19.2313 28.3007C19.7188 28.0667 20.3038 28.2617 20.5378 28.7297C20.7718 29.2172 20.5768 29.8022 20.1088 30.0362L15.5068 32.3372L25.9978 37.5827L36.4888 32.3372L31.8868 30.0362C31.7712 29.9804 31.6681 29.9018 31.5836 29.8052C31.4991 29.7086 31.4349 29.596 31.3948 29.4741C31.3548 29.3521 31.3397 29.2234 31.3505 29.0955C31.3614 28.9676 31.3978 28.8432 31.4578 28.7297C31.6918 28.2422 32.2768 28.0472 32.7643 28.3007L39.1018 31.4597C39.2666 31.5396 39.4056 31.6642 39.5029 31.8194C39.6002 31.9746 39.6518 32.1541 39.6518 32.3372C39.6518 32.5204 39.6002 32.6998 39.5029 32.855C39.4056 33.0102 39.2666 33.1349 39.1018 33.2147L26.4268 39.5522C26.2903 39.6302 26.1343 39.6497 25.9978 39.6497Z"
        fill={pathColor}
      />
    </svg>
  )
}
